import React from 'react'
import { CellWithContextMenu } from '@ztechapps/webui.menu'
import { RowContextMenu } from './RowContextMenu'
import type { Template } from '@ztechapps/common.contract'

export const TemplateValueRow = (props: Template) => {
  const { value } = props
  return (
    <tr>
      <CellWithContextMenu contextMenuContent={<RowContextMenu template={props} />}>
        <div>{value}</div>
      </CellWithContextMenu>
    </tr>
  )
}
